import { render, staticRenderFns } from "./EcgDialog.vue?vue&type=template&id=5ef2bb2b&scoped=true&"
import script from "./EcgDialog.vue?vue&type=script&lang=js&"
export * from "./EcgDialog.vue?vue&type=script&lang=js&"
import style0 from "./EcgDialog.vue?vue&type=style&index=0&id=5ef2bb2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2bb2b",
  null
  
)

export default component.exports